import client from "../libs/HttpClient";

class TopicServices {
  static TopicList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/topic?page=${page_no}`, request);
  }
  static addTopic(request) {
    return client.post(`/add-topic`, request, {});
  }
  static updateTopic(request) {
    return client.post(`/edit-topic`, request, {});
  }
  static viewTopic(params) {
    return client.get(`/get-topic`, { params });
  }
  static deleteTopic(params) {
    return client.delete(`/delete-topic`, { params });
  }
  static updateStatusTopic(request) {
    return client.post(`/change-status-topic`, request);
  }
}
export { TopicServices };
